<template>
  <div>
    <template v-if="this.data != null">
      <template v-if="data.upgrade.unitName !== 'None'">
        <v-overlay :value="overlay" opacity="0.75">
          <v-row class="ma-2">
            <v-col cols="12" align="center"> {{ $t("upgrade.heading") }} </v-col>
            <v-col cols="12" align="center">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-col>

            <v-row justify="center" class="ma-2">
              <v-col align="center" class="ma-auto"> {{ $t("upgrade.unit") }}: {{ data.upgrade.unitName }}</v-col>
            </v-row>

            <v-progress-linear v-model="percentage" color="primary" height="35" rounded>
              <template v-slot:default="{ value }">
                <strong> {{ Math.ceil(value) }} % </strong> &nbsp;
                <small>
                  <i> ({{ progress }} / {{ progressMax }} kB) </i>
                </small>
              </template>
            </v-progress-linear>
          </v-row>

          <v-row justify="center" class="ma-2">
            <v-col cols="12" align="center">
              <v-btn small color="primary" class="white--text" @click="overlay = !overlay">
                {{ $t("upgrade.hide") }}
                <v-icon right> mdi-cancel </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-overlay>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";

import * as MyComm from "../codes/comm.js";

import { ServiceClient } from "../../service_client/index.js";

export default {
  name: "UpgradeCore",
  props: {},
  data() {
    return {
      timer: null,

      overlay: true,

      progress: 0,
      progressMax: 0,

      percentage: 0,

      data: null,
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.pollData();
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    pollData() {
      this.timer = setInterval(() => {
        this.getData();
      }, 1000);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("upgrade"), null, null, "GET")
        .then((data) => {
          this.data = data;

          if ("unit" in this.data.upgrade) {
            this.data.upgrade.unit = "0x" + this.data.upgrade.unit;

            if ("lastRequestedPacket" in this.data.upgrade) {
              this.progress = (this.data.upgrade.lastRequestedPacket * 8) / 1000;
            }

            if ("totalPackets" in this.data.upgrade) {
              this.progressMax = (this.data.upgrade.totalPackets * 8) / 1000;
            }

            if (this.progressMax != 0) {
              if (this.progress < this.progressMax) {
                this.percentage = (this.progress / this.progressMax) * 100;
              } else {
                this.percentage = 0;
              }
            } else {
              this.percentage = 0;
            }

            this.progress = this.progress.toFixed(2);
            this.progressMax = this.progressMax.toFixed(2);

            if ("unit" in this.data.upgrade) {
              this.data.upgrade.unitName = MyComm.getDeviceName(this.data.upgrade.unit);
            } else {
              this.data.upgrade.unitName = MyComm.getDeviceName(0x00);
            }
          } else {
            this.data.upgrade.unitName = MyComm.getDeviceName(0x00);
          }
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  destroyed() {},
  watch: {
    overlay() {
      setTimeout(() => {
        this.overlay = true;
      }, 5000);
    },
  },
};
</script>

<style scoped></style>
